/**
 *  SPサイズ時に開いてるグローバルナビを閉じるjs
 *
 *  Collapse (bootstrap-v4-alpha)
 *  http://v4-alpha.getbootstrap.com/components/collapse/
 */

import ua from '../util/ua';

const closeNav = () => {
  const $gnav = $('#gnav');
  const $collapseNavbar = $('#collapse-navbar');
  const $target = $('.nav-link');

  $gnav.on('click', $target, () => {
    $collapseNavbar.collapse('hide');
  });
};

export default closeNav;



// WEBPACK FOOTER //
// ./src/scripts/common/closeNav.js